<template>
  <div>
    <b-container class="check_tool__pannel__result">
      <b-row>
        <b-col>
          Posture:
          <b>{{ posture }}</b>
        </b-col>
        <b-col>
          Occl:
          <b>{{ occlusion }}</b>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          Cover:
          <b>{{ cover }}</b>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          hasHand:
          <b>{{ hasHand }}</b>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          hasPacifier:
          <b>{{ hasPacifier }}</b>
        </b-col>
      </b-row>
      <b-row>
        <b-col>occlu_debug: {{ occlDetail }}</b-col>
      </b-row>
      <b-row>
        <b-col>cover_debug: {{ coverDetail }}</b-col>
      </b-row>
      <b-row>
        <b-col>eye_open_debug: {{ eye_open_debug }}</b-col>
      </b-row>
      <b-row>
        <b-col>----------------------</b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            variant="success"
            v-b-modal.gradCamModal
            @click="getGradcam()"
            :disabled="enableVisualize"
            >Visualization</b-button
          ></b-col
        >
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-button variant="success" @click="feedback()" style="margin-top: 20"
            >Feedback</b-button
          >
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>
          <span class="text-danger"
            >Note: If [eye_open_debug] value higher than 0.7, the baby's eyes
            are open.</span
          >
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="gradCamModal" title="Gradcam Visualization" size="lg">
      <div align="center">
        <img :src="src" alt width="600" height="500" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import client from "@/api/client";

export default {
  props: {
    PropsSleepResult: null,
    PropsEnableVisualize: null,
    ProbsItem: null,
    ProbsUserId: null,
  },
  data() {
    return {
      posture: "None",
      cover: "None",
      occlusion: "None",
      coverDetail: [],
      occlDetail: [],
      hasHand: -1,
      hasPacifier: -1,
      enableVisualize: false,
      imageObj: null,
      src: null,
      eye_open_debug: [],
    };
  },
  watch: {
    PropsSleepResult() {
      this.resetDetectResult();
      const result = this.PropsSleepResult;

      // parse detection result from AI server
      this.posture = result.posture;
      if ("occlusion" in result) {
        this.occlusion = result.occlusion;
        this.cover = result.cover;
        this.coverDetail = result.cover_debug;
        this.occlDetail = result.occ_debug;
        this.hasHand = result.has_hand;
        this.hasPacifier = result.has_pacifier;
        this.eye_open_debug = result.eye_open_debug;
      }
    },
    PropsEnableVisualize() {
      this.enableVisualize = this.PropsEnableVisualize;
    },
  },
  methods: {
    resetDetectResult() {
      this.posture = "None";
      this.cover = "None";
      this.occlusion = "None";
      this.hasHand = -1;
      this.hasPacifier = -1;
    },
    feedback() {
      const item = this.ProbsItem;
      const body = {
        user_id: this.ProbsUserId,
        feedback_alert_type: "CUBO_ALERT_NOT_IN_BED",
        batch_type: "sleep_main",
        name: item.name,
        roi: item.dzone,
        key: item.key,
      };

      client.post("feedback/pipeline", null, body).then((res) => {
        console.log(res);
      });
    },
    getGradcam() {
      console.log("getting gradcam....");
      const vm = this;
      const item = this.ProbsItem;
      const key = `${item.user_id}/${item.device_id}/alert/${item.date}/${item.name}`;
      const body = {
        bucket_type: "prod",
        key,
        detect_zone: item.detect_zone,
        gradcam: true,
      };
      client.postBlob("/test/sleep", null, body).then((res) => {
        console.log(res);
        vm.imageObj = new Image();
        vm.imageObj.src = URL.createObjectURL(res);
        vm.imageObj.onload = () => {};

        const reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onload = () => {
          vm.src = reader.result;
        };
      });
    },
  },
};
</script>
